import { defineMessages } from 'react-intl'

export default defineMessages({
  authorizeError: {
    id: 'Oauth2DatasourceCallbackPage.authorizeError',
    defaultMessage: 'Unable to setup connection. Please return to the application and try again.'
  },
  connectionError: {
    id: 'Oauth2DatasourceCallbackPage.connectionError',
    defaultMessage: 'Your data source connection session has expired. Please return to the application and try again.'
  },
  authorizeLoading: {
    id: 'Oauth2DatasourceCallbackPage.authorizeLoading',
    defaultMessage: 'Hold tight while we set up your datasource connection...'
  },
  connectionLoading: {
    id: 'Oauth2DatasourceCallbackPage.connectionLoading',
    defaultMessage: 'Your data source is being connected...'
  }
})
